import { useDispatch, useSelector } from 'react-redux';
import React from 'react';

import { FieldsWrapper } from '../../../../../r/components/shared/input-field/styled';
import OTP from '../../../../../r/components/shared/input-field/otp';
import { updateFeedback, updateModel } from '../../reducers';
import { confirm2FA } from '../../slices';
import { FormWrapper } from '../styled';
import FormFooter from '../form-footer';
import Feedback from '../feedback';

const Confirm2FA = () => {
  const { model } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleOTPChange = (_, otp) => dispatch(updateModel({ otp }));

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateFeedback());
    dispatch(confirm2FA());
  };

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <div className="header">
        <h1>Hi, Welcome Back!</h1>
        <p>Enter your Authenticator Code</p>
      </div>

      <FieldsWrapper>
        <Feedback />
        
        <OTP
          onChange={handleOTPChange}
          label="Enter Codes"
          value={model.otp}
          size="large"
          required
          block
        />
      </FieldsWrapper>

      <FormFooter />
    </FormWrapper>
  );
};

export default Confirm2FA;